import { Localisation } from './localisation.model';
import { CaracteristiqueParcelle } from './caracteristique-parcelle.model';
import { Espece } from './espece.model';
import { Variete } from './variete.model';
import { RefPorteGreffe } from './ref-porte-greffe.model';
import { UniteCulturaleVigne } from './unite-culturale-vigne.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class UniteCulturale {
    static jsonMap = {
        id: { key: 'id', optional: true },
        localisation: { key: 'localisation', converter: new (ClassConverterFactory.build(Localisation))() },
        caracteristiqueParcelle: { key: 'caracteristiqueParcelle', converter: new (ClassConverterFactory.build(CaracteristiqueParcelle))() },
        uniteCulturaleVigne: { key: 'uniteCulturaleVigne', converter: new (ClassConverterFactory.build(UniteCulturaleVigne))(), optional: true },
        numBlocFruitier: { key: 'numBlocFruitier', optional: true, default: '' },
        numTracabilite: { key: 'numTracabilite', optional: true, default: '' },
        codeParcelle: { key: 'codeParcelle', optional: true, default: '' },
        espece: { key: 'espece', converter: new (ClassConverterFactory.build(Espece))() },
        variete: { key: 'variete', converter: new (ClassConverterFactory.build(Variete))() },
        anneePlantation: { key: 'anneePlantation', optional: true },
        anneePremiereFeuille: { key: 'anneePremiereFeuille', optional: true },
        anneeSurgreffage: { key: 'anneeSurgreffage', optional: true },
        distanceIntraRang: { key: 'distanceIntraRang' },
        distanceInterRang: { key: 'distanceInterRang' },
        nbArbre: { key: 'nbArbre' },
        confusion: { key: 'confusion', optional: true },
        surfaceCalculee: { key: 'surfaceCalculee' },
        porteGreffe: { key: 'porteGreffe', converter: new (ClassConverterFactory.build(RefPorteGreffe))(), optional: true }
    };

    public id: number;
    public localisation: Localisation;
    public caracteristiqueParcelle: CaracteristiqueParcelle;
    public uniteCulturaleVigne: UniteCulturaleVigne;
    public numBlocFruitier: string;
    public numTracabilite: string;
    public codeParcelle: string;
    public espece: Espece;
    public variete: Variete;
    anneePlantation: number;
    anneePremiereFeuille: number;
    anneeSurgreffage: number;
    distanceIntraRang: number;
    distanceInterRang: number;
    nbArbre: number;
    confusion: boolean;
    surfaceCalculee: number;
    public porteGreffe: RefPorteGreffe;

    public getInfosTracabilite(): string {
        if (this.codeParcelle) {
            return this.codeParcelle;
        } else if (this.localisation.referenceCadastrale) {
            return this.localisation.referenceCadastrale;
        } else {
            return this.numTracabilite;
        }
    }
    public getInfosAnnee(): number {
        if (this.anneeSurgreffage) {
            return this.anneeSurgreffage;
        } else if (this.anneePlantation) {
            return this.anneePlantation;
        } else {
            return this.anneePremiereFeuille;
        }
    }
}
